import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b21c6e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bulk-action-label" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PDF downloaden", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Losse PDF's downloaden", -1))

import { computed, ref } from 'vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import TableSettings from '@/types/tableSettings'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueBulkActions',
  props: {
    selectedRows: null,
    tableSettings: null
  },
  setup(__props: any) {

const props = __props as { selectedRows:number[], tableSettings:TableSettings };


const downloading = ref(false)

const selectedText = computed(() => {
  return props.selectedRows.length === 1
    ? '1 servicemelding geselecteerd'
    : props.selectedRows.length + ' servicemeldingen geselecteerd'
})

function downloadAsExcel () {
  downloading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/issues/download/excel', { issueIds: props.selectedRows }, { responseType: 'arraybuffer' }).then(r => {
    const url = window.URL.createObjectURL(new Blob([r.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Export_Servicemeldingen_' + getCurrentDate() + '.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    notification.success({
      message: 'Download gestart.',
      description: 'De download is succesvol gestart. Ga naar je download map om de Excel export te bekijken.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Download NIET gestart.',
      description: 'De download is mislukt. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    downloading.value = false
  })
}

function downloadAsPdf () {
  downloading.value = true
  const payload: { selectedIds:number[], sorting: { column:string, order:string } | null } = {
    selectedIds: props.selectedRows,
    sorting: null
  }

  if (props.tableSettings.sort) {
    payload.sorting = {
      column: props.tableSettings.sort.columnKey,
      order: props.tableSettings.sort.order
    }
  }

  axios.post(process.env.VUE_APP_API_URL + '/issues/download/pdf', payload, { responseType: 'arraybuffer' }).then(r => {
    const url = window.URL.createObjectURL(new Blob([r.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Export_Servicemeldingen_' + getCurrentDate() + '.pdf')
    document.body.appendChild(link)
    link.click()
    link.remove()
    notification.success({
      message: 'Download gestart.',
      description: 'De download is succesvol gestart. Ga naar je download map om de PDF export te bekijken.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Download NIET gestart.',
      description: 'De download is mislukt. Probeer het later nog een keer.',
      duration: 0
    })
  }).finally(() => {
    downloading.value = false
  })
}

async function downloadAsSeparatePdfs () {
  downloading.value = true

  const payload = {
    types: [],
    private: true
  }

  const downloads = await Promise.allSettled(
    props.selectedRows.map(async (issueId:number) => {
      const response = await axios.post(`${process.env.VUE_APP_API_URL}/issues/${issueId}/export`, payload, { responseType: 'blob' })
      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', `Export_Servicemelding_${issueId}.pdf`)

      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    })
  )

  const failedDownloads = downloads.filter(download => download.status === 'rejected').length

  if (failedDownloads === 0) {
    notification.success({
      message: 'Downloads gestart.',
      description: 'De losse PDF downloads zijn succesvol gestart. Ga naar je download map om de exports te bekijken.',
      duration: 5
    })
  } else if (failedDownloads === downloads.length) {
    notification.error({
      message: 'Downloads NIET gestart.',
      description: 'De losse PDF downloads zijn mislukt. Probeer het later nog een keer.',
      duration: 0
    })
  } else {
    notification.warning({
      message: 'Downloads deels gestart.',
      description: `${downloads.length - failedDownloads} van de ${downloads.length} losse PDF downloads zijn gestart.`,
      duration: 5
    })
  }

  downloading.value = false
}

function getCurrentDate () : string {
  return new Date().toLocaleDateString('nl-NL')
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown_button = _resolveComponent("a-dropdown-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createElementVNode("label", _hoisted_1, _toDisplayString(_unref(selectedText)), 1),
          _hoisted_2,
          _createVNode(_component_a_dropdown_button, {
            onClick: downloadAsExcel,
            disabled: downloading.value,
            loading: downloading.value,
            trigger: ['click']
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { style: { width: '200px' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, {
                    key: "0",
                    onClick: downloadAsPdf
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, {
                    key: "1",
                    onClick: downloadAsSeparatePdfs
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Excel downloaden ")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})